export default "__VITE_ASSET__B_5kP2oI__"